import React from "react";

function Contact() {
  return (
    <div>
      <h1>Contacto</h1>
    </div>
  );
}

export default Contact;
